import { api } from './api';
import type { Gebruiker } from '@types';

// ============================================
// Gebruiker API Functions
// ============================================

/**
 * Haal alle gebruikers op
 * @returns Array van gebruikers
 */
export const getGebruikers = async (): Promise<Gebruiker[]> => {
  const response = await api.get<Gebruiker[]>('/gebruikers');
  return response.data;
};
